import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TagAcquisitionModel } from 'src/app/models/acquisition/TagAcquisitionModel';

@Component({
    selector: 'app-modal-deviant-tags',
    templateUrl: './modal-deviant-tags.component.html',
    styleUrls: ['./modal-deviant-tags.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeviantTagsComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TagAcquisitionModel
  ) { }

  ngOnInit(): void {
  }

}
